(() => {
  function init(scope) {
    scope.querySelectorAll('[data-pro-home-motion]').forEach(container => {
      if (container.dataset.ready) return;
      container.dataset.ready = 'true';
      const video = container.querySelector('video');
      const button = container.querySelector('button');
      const source = video.querySelector('source');
      let visible = false;
      let userPaused = false;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      button.hidden = false;
      function syncButton() {
        button.classList.toggle('is-paused', video.paused);
        button.setAttribute('aria-label', video.paused ? button.dataset.resume : button.dataset.pause);
      }
      function load() {
        if (source.hasAttribute('src')) return;
        source.src = source.dataset.src;
        video.load();
      }
      function play() {
        if (!visible || userPaused || document.hidden) return;
        load();
        video.muted = true;
        video.play().catch(syncButton);
      }
      video.addEventListener('play', syncButton);
      video.addEventListener('pause', syncButton);
      video.addEventListener('canplay', play);
      button.addEventListener('click', () => {
        userPaused = !video.paused;
        if (userPaused) video.pause();
        else play();
      });
      const preloadObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          load();
          preloadObserver.disconnect();
        }
      }, {rootMargin: '400px'});
      preloadObserver.observe(container);
      const visibilityObserver = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        if (visible) play();
        else video.pause();
      }, {threshold: 0.15});
      visibilityObserver.observe(container);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else play();
      });
      syncButton();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
